import React, { useMemo } from 'react';

import type { DetailLevel, Format } from '@eluve/blocks';
import {
  Heading,
  LoadingIcon,
  Separator,
  Stack,
  Text,
} from '@eluve/components';
import { EluveRenderer } from '@eluve/sdui-renderer';
import { SAMPLE_PREVISIT_PATIENT_NAME } from '@eluve/sdui-types';
import type { Spec } from '@eluve/sdui-types';

import { getPreviewSpec } from './insightsPreviewData';

interface InsightsPreviewPanelProps {
  format: Format;
  detailLevel: DetailLevel;
  generatedSpec?: Spec | null;
  isGenerating?: boolean;
  patientName?: string;
}

export const InsightsPreviewPanel: React.FC<InsightsPreviewPanelProps> = ({
  format,
  detailLevel,
  generatedSpec,
  isGenerating,
  patientName = SAMPLE_PREVISIT_PATIENT_NAME,
}) => {
  const staticSpec = useMemo(
    () => getPreviewSpec(format, detailLevel),
    [format, detailLevel],
  );

  const showGenerated = !isGenerating && generatedSpec != null;

  return (
    <div className="w-full rounded-lg bg-bg-primary p-5">
      <Stack gap={4} align="stretch">
        <Heading size="2xl" weight="semibold">
          Preview Insights
        </Heading>
        <Separator className="my-2" />
        <Heading size="xl">{patientName}</Heading>
        {isGenerating ? (
          <Stack
            gap={2}
            align="center"
            justify="center"
            className="py-12"
            direction="vertical"
          >
            <LoadingIcon size="lg" />
            <Text size="sm" color="tertiary">
              Generating preview…
            </Text>
          </Stack>
        ) : (
          <EluveRenderer spec={showGenerated ? generatedSpec : staticSpec} />
        )}
      </Stack>
    </div>
  );
};
